<template>
    <div>
        <md-progress-spinner v-if="isLoading"
            md-mode="indeterminate">
        </md-progress-spinner>

        <detail v-else
            :edit-mode="true">
        </detail>
    </div>
</template>

<script>
import _ from 'lodash'
import ordersService from '@/components/orders/services/'
import productsStatusService from '@/components/products/services/productsStatus.js'
import unitsService from '@/components/units/services/'
import organizationsService from '@/components/organizations/services/organizations'
import Utils from '@/utils/utils'
import Detail from '@/components/orders/Detail'
import OrderStatus from '@/utils/orderStatus'
import luxon from '@/mixins/luxon'

const loadingKeys = {
    fetchingItem: 'fetching-item'
}

export default {
    mixins: [luxon],

    components: {
        Detail
    },

    data () {
        return {
            order: {},

            productStatus: [],

            units: [],

            loadings: []
        }
    },

    computed: {
        isLoading () {
            return this.isFetchingProducts
        },

        isFetchingProducts () {
            return !!this.loadings.filter(
                loading => loading.key === loadingKeys.fetchingItem
            ).length
        }
    },

    methods: {
        async fetchImage (product) {
            return Utils.getBase64(product.picture_url)
        },

        async fetchOrder (orderId) {
            let self = this

            let params = {
                filter: {
                    order_id: orderId
                }
            }

            let response = await ordersService.retrieve(params)

            let results = response.data.results[0]

            self.order = results
        },

        async fetchProducts (orderId) {
            let self = this

            _.fill(self.loadings, loadingKeys.fetchingItem)

            let params = {
                filter: {
                    order_id: orderId
                }
            }

            let response = await ordersService.retrieveItems(params)
            // eslint-disable-next-line
            let results = response.data
            results = results.map(result => {
                result.selected = (result.order_item_status_id === OrderStatus.orderItem.PENDING || result.order_item_status_id === OrderStatus.orderItem.DELIVERED)
                return result
            })

            for (const product of response.data) {
                product.picture_b64 = await this.fetchImage(product)
            }

            this.order.products = _.cloneDeep(response.data)

            _.pull(self.loadings, loadingKeys.fetchingItem)
        },

        async fetchProductStatus () {
            let self = this

            let params = {}

            let response = await productsStatusService.getProductsStatus(params)
            self.productStatus = _.cloneDeep(response.data.results)
        },

        async fetchUnits () {
            let self = this

            let params = {
                filter: {
                    active: 1
                }
            }

            let response = await unitsService.retrieve(params)
            self.units = _.cloneDeep(response.data.results)
        },

        concatOrganizationAddress (organization) {
            return (
                (organization[0].street ? organization[0].street + '\n' : '') +
                (organization[0].zip_code ? organization[0].zip_code + '\n' : '') +
                (organization[0].city ? organization[0].city + '\n' : '')
            )
        },

        async fetchOrganization () {
            let self = this

            let params = {
                filter: {
                    organization_id: self.order.organization_id
                }
            }

            let response = await organizationsService.retrieve(params)
            self.order.address = self.concatOrganizationAddress(response.data.results)
            self.order.preferred_delivery_hour = this.formatTimeSimple(response.data.results[0].preferred_delivery_hour)
        },

        cancel () {
            this.$router.go(-1)
        }
    },

    async created () {
        this.$store.dispatch('emptyHistoricCart')

        let data = parseInt(this.$route.params.id)

        let metadatas = [
            this.fetchProductStatus(),
            this.fetchUnits()
        ]

        Promise.all(metadatas)

        if (data) {
            // fetch order
            await this.fetchOrder(data)

            // fetch order products
            await this.fetchProducts(data)

            // fetch additional order data
            await this.fetchOrganization()

            this.$store.dispatch('loadHistoricCart', this.order)
        }
    }
}
</script>
